<template>
  <div id="qrCode" style="width: 380px;height: 380px;" ref="qrCodeDiv"></div>
</template>

<script>
import QRCode from 'qrcodejs2';
export default {
  data () {
    return {
      id: 0,
      orderTimer: null
    }
  },
  created () {
    this.orderTimer = setInterval(this.getOrder, 5000)
  },
  methods: {
    async getOrder () {
      this.$refs.qrCodeDiv.innerHTML = ''
      let url = 'duozhuayu/pay/check_approved_unpaid_orders'
      const { data: res } = await this.$http.get(url)
      if (res.code === 200) {
        this.bindQRCode(res.data.code_url)
        this.checkOrder(res.data.id)
      }
    },
    async checkOrder (id) {
      let url = 'duozhuayu/pay/queryPayment?id=' + id
      const { data: res } = await this.$http.get(url)
      if (res.code === 200) {
      } else {
      }
    },
    bindQRCode: function (code_url) {
      new QRCode(this.$refs.qrCodeDiv, {
        text: code_url,
        width: 380, // 设置宽度为容器的宽度
        height: 380, // 设置高度为容器的高度
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })
    },
  },
  components: {}
}
</script>

<style scoped></style>
